<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div class="flex flex-wrap align-items marginBottom20">

          <div class="flex align-items marginRight10 marginBottom10">
            <span class="span marginRight10">优惠券编号: </span>
            <div class="width200">
              <el-input
                v-model="searchData.code"
                placeholder="请输入"
                @keyup.enter.native="handleSearch"
                clearable
                maxlength="20"
              ></el-input>
            </div>
          </div>

          <div class="flex align-items marginRight10 marginBottom10">
            <span class="span marginRight10">优惠券名称: </span>
            <div class="width200">
              <el-input
                v-model="searchData.name"
                placeholder="请输入"
                @keyup.enter.native="handleSearch"
                clearable
                maxlength="20"
              ></el-input>
            </div>
          </div>

          <div class="flex align-items marginRight10 marginBottom10">
            <span class="span marginRight10">关联平台: </span>
            <div class="width200">
              <el-select
                class="width200"
                v-model="searchData.platform"
                clearable
                @change="handleSearch"
              >
                <el-option
                  value=""
                  label="请选择"
                ></el-option>
                <el-option
                  :value="1"
                  label="美团"
                ></el-option>
                <el-option
                  :value="2"
                  label="抖音"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="flex align-items marginRight10 marginBottom10">
            <span class="span marginRight10">关联平台优惠券号: </span>
            <div class="width200">
              <el-input
                v-model="searchData.platformCouponCode"
                placeholder="请输入"
                @keyup.enter.native="handleSearch"
                clearable
                maxlength="50"
              ></el-input>
            </div>
          </div>

          <div class="flex align-items marginRight10 marginBottom10">

            <el-button
              size="medium"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              class="marginLeft10"
            >查询</el-button>
          </div>

          <div class="flex align-items marginRight10 marginBottom10">
            <el-button
              size="medium"
              type="info"
              icon="el-icon-refresh-right"
              @click="handleReset"
              class="marginLeft10"
            >重置</el-button>

          </div>

          <div class="flex align-items marginRight10 marginBottom10">
            <el-button
              size="medium"
              type="primary"
              icon="el-icon-plus"
              @click="handleCreate"
            >添加</el-button>
          </div>

        </div>
      </template>

      <template
        slot="state"
        slot-scope="{ row }"
      >
        <el-switch
          v-model="row.state"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event,row.id)"
        ></el-switch>
      </template>
      <template
        slot="menu"
        slot-scope="{ row }"
      >
        <el-button
          v-if="row.state == 2"
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="handleEdit(row)"
        >编辑</el-button>
        <el-button
          type="text"
          size="mini"
          icon="el-icon-delete"
          @click="handleDelete(row)"
        >删除</el-button>
      </template>
    </avue-crud>

    <el-dialog
      v-if="dialogVisible"
      :title="`${formTit}关联`"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <avue-form
        ref="form"
        v-model="form"
        :option="formOption"
        @submit="submit"
      >

        <template slot="couponId">
          <el-select
            v-model="form.couponId"
            placeholder="请选择优惠劵编号"
            @change="getCouponNameHandle"
            filterable=true
            :disabled="formTit == '编辑' ? true : false"
          >
            <el-option
              v-for="item in couponList"
              :key="item.id"
              :label="item.code"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>

     
        <template slot="couponName">
          {{ form.couponName || '选择优惠券后自动带出' }}
        </template>

        <template slot="platform">
          <el-select
            v-model="form.platform"
            placeholder="请选择关联平台"
            :disabled="formTit == '编辑' ? true : false"
          >
            <el-option
              v-for="item in platFormList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="platformCouponCode">
          <el-input
            v-model="form.platformCouponCode"
            placeholder="请输入关联平台优惠券号"
            :disabled="formTit == '编辑' ? true : false"
          />
        </template>

        <template slot="platformPrice">
          <el-input
            v-model="form.platformPrice"
            placeholder="请输入"
            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)"
            @blur="salaryDianChange($event,'platformPrice',999999.99)"
            type="text"
            clearable
          />
        </template>

        <template slot="sort">
          <el-input
            v-model="form.sort"
            placeholder="请输入"
            onkeyup="this.value=this.value.replace(/[^\d]+/g,'')"
            @blur="salaryChange($event,'sort',999999)"
            type="text"
            clearable
          />
        </template>

        <template slot="state">
          <el-switch
            v-model="form.state"
            :inactive-value="2"
            :active-value="1"
          ></el-switch>
        </template>

        <template slot="menuForm">
          <el-button
            icon="el-icon-close"
            @click="handleClose"
          >取消</el-button>
        </template>
      </avue-form>
    </el-dialog>

    <el-dialog
      title="可用区域"
      :visible.sync="dialogTableVisibleUse"
    >
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="dialogTableVisibleUse = false"
        >确 定</el-button>
      </div>
      <el-table :data="useList">
        <el-table-column
          property="code"
          label="区域编号"
        ></el-table-column>
        <el-table-column
          property="name"
          label="姓名"
        ></el-table-column>
        <el-table-column
          property="state"
          label="地址"
        >
          <template slot-scope="scope">
            {{ scope.state==1?'正常':scope.state==2?'冻结':'' }}
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  add,
  deleteNew,
  list,
  update,
  updateNew,
  view,
  getCouponList,
} from "@/api/coupon/relate";
export default {
  name: "index",
  data() {
    return {
      formTit:'',
      searchData: {
        type: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      platFormList:[
      { label: "美团", value: 1 },
       { label: "抖音", value: 2 }
      ],
      useList: [],
      tableData: [],
      couponList: [],
      showLoading: false,
      option: {
        title: "优惠券关联",
        titleSize: "h3",
        card: true,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "优惠劵编号",
            prop: "code",
          },
          {
            label: "优惠劵名称",
            prop: "name",
          },
          {
            label: "领取数量",
            prop: "drawNum",
          },
          {
            label: "库存（张）",
            prop: "drawNum",
          },
          {
            label: "关联平台",
            prop: "platform",
            formatter: function (row, column, cellValue) {
              return row.platform == 1 ? "美团" : row.platform == 2 ? "抖音" : "";
            },
          },
          {
            label: "关联平台优惠券号",
            prop: "platformCouponCode",
          },
          {
            label: "平台售价（元）",
            prop: "platformPrice",
          },
          {
            label: "关联状态",
            prop: "state",
            formatter: function (row, column, cellValue) {
              return row.state === 1
                ? "上架"
                : row.state === 2
                ? "下架"
                : row.state;
            },
          },
        ],
      },
      dialogTableVisibleUse: false,
      dialogVisible: false,
      form: {
        id: "",
        type: "",
        name: "",
      },
      formOption: {
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "140",
        column: [
          {
            label: "优惠券编号",
            prop: "couponId",
            type: "select",
            dicData: [],
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择优惠券编号",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value === "") {
                    callback(new Error("请选择优惠券编号"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "优惠券名称",
            prop: "couponName",
            span: 24,
            maxlength: 4,
            showWordLimit: true,
          },
          {
            label: "关联平台",
            prop: "platform",
            type: "select",
            dicData: [],
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择关联平台",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value === "") {
                    callback(new Error("请选择关联平台"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "关联平台优惠券号",
            prop: "platformCouponCode",
            span: 24,
            maxlength: 50,
            showWordLimit: true,
          },
          {
            label: "平台售价（元）",
            prop: "platformPrice",
            span: 24,
            maxlength: 4,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: "请输入平台售价",
                trigger: "blur",
              },
            ],
          },
          {
            label: "关联状态",
            prop: "state",
            span: 24,
            maxlength: 4,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: "请选择上架状态",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  created() {
    this.getCouponList();
    const searchForm = JSON.parse(localStorage.getItem("searchForm"));
    if (searchForm?.path === this.$route.path) {
      this.searchData = searchForm.searchData;
    } else {
      localStorage.removeItem("searchForm");
    }
  },
  methods: {

    salaryChange(e, t, max) {
      const value = e.target.value;
      if (value) {
        if (isNaN(value * 1)) {
          this.form[t] = "";
          e.target.value = "";
        } else {
          if (value > max) {
            this.form[t] = max;
            e.target.value = max;
          } else {
            this.form[t] = value * 1;
            e.target.value = value * 1;
          }
        }
      } else {
        this.form[t] = "";
      }
    },
    salaryDianChange(e, t, max) {
      const value = e.target.value;
      if (value) {
        if (isNaN(value * 1)) {
          this.form[t] = "";
          e.target.value = "";
        } else {
          if (value > max) {
            this.form[t] = max.toFixed(2);
            e.target.value = max.toFixed(2);
          } else {
            this.form[t] = parseFloat(value).toFixed(2);
            e.target.value = parseFloat(value).toFixed(2);
          }
        }
      } else {
        this.form[t] = "";
        delete this.form[t]
      }
    },
    // 获取优惠劵列表
    getCouponList() {
      getCouponList().then((res) => {
        if (res.code === 200) {
          this.couponList = res.data;
          console.log(" this.couponList ", this.couponList);
        }
      });
    },
    getCouponNameHandle(e) {
      this.form.couponName = this.couponList.find((item) => item.id === e).name;
    },
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      localStorage.setItem("searchForm", JSON.stringify({ ...searchForm }));
      this.showLoading = true;
      list({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    // 添加
    handleCreate() {
      this.formTit='新增'
      this.option.title='新增关联'
      // console.log('添加')
      this.dialogVisible = true;
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      localStorage.removeItem("searchForm");
      // console.log('重置')
      this.searchData = {
        type: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 编辑
    async handleEdit(row) {
      this.formTit='编辑'
      this.option.title='新增关联'
      // console.log('编辑',row)
      const { data } = await view({
        id: row.id,
      });
      console.log("data", data);
      this.form = data;
      this.form.couponName = this.couponList.find(
        (item) => item.id === data.couponId
      )?.name;
      this.dialogVisible = true;
    },
    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteNew({
          id: row.id,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    //修改状态
    handleSwitch(e, id) {
      // console.log(e,id)
      updateNew({
        id: id,
        state: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.msg);
        }
        this.onLoad();
      });
    },

    // 提交
    submit(form, done) {
      // console.log(form)
      if (form.id) {
        update(form)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.dialogVisible = false;
              setTimeout(() => {
                this.resetForm();
              }, 500);
              this.onLoad();
            } else {
              this.$message.error(res.msg);
              done();
            }
          })
          .catch(() => done());
      } else {
        add(form)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.dialogVisible = false;
              setTimeout(() => {
                this.resetForm();
              }, 500);
              this.onLoad();
            } else {
              this.$message.error(res.msg);
              done();
            }
          })
          .catch(() => done());
      }
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
        name: "",
      };
    },
  },
};
</script>

<style scoped>
</style>